import { Combobox } from '@/components/common/Combobox'
import { useTaskDocumentTypes } from '../../hooks'

interface Props {
  value: string | null
  onChange: (code: string | null) => void
  className?: string
}

/** Combobox kategorii dokumentu przy uploadzie / edycji. Pełne listy są krótkie (5-10 typów),
 *  więc search ukryty (threshold 8). emptyOptionLabel daje możliwość wybrania "bez kategorii". */
export function DocumentTypeSelect({ value, onChange, className }: Props) {
  const { data: types = [], isLoading } = useTaskDocumentTypes()

  const options = types.map((t) => ({ value: t.code, label: t.label }))

  return (
    <Combobox<string>
      value={value}
      onChange={onChange}
      options={options}
      placeholder="-- bez kategorii --"
      emptyOptionLabel="-- bez kategorii --"
      disabled={isLoading}
      className={className}
    />
  )
}
